import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import VideoCard from '../components/VideoCard';
import './Search.css';

function Search() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q');
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (query) {
      searchVideos(query);
    }
  }, [query]);

  const searchVideos = async (searchQuery) => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/search?q=${encodeURIComponent(searchQuery)}`);
      setVideos(response.data);
    } catch (err) {
      console.error('Error searching videos:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Searching...</p>
      </div>
    );
  }

  return (
    <div className="search-page">
      <h2 className="search-results-title">
        Search results for "{query}"
      </h2>
      
      {videos.length === 0 ? (
        <div className="no-results">
          <p>No videos found matching your search.</p>
          <p className="no-results-hint">Try different keywords or check your spelling.</p>
        </div>
      ) : (
        <div className="video-grid">
          {videos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      )}
    </div>
  );
}

export default Search;
